import React from 'react'

export const qanda = [
  {
    q: 'Wer darf wählen?',
    a: (
      <>
        Wahlberechtigt ist zunächst jeder der rund 330 Millionen US-Bürger, der
        mindestens 18 Jahre alt ist. Ausgeschlossen sind Bewohner von
        US-Aussengebieten wie Puerto Rico sowie vielerorts Häftlinge und
        Menschen, die wegen einer schweren Straftat verurteilt wurden. Alle
        anderen Bürger müssen sich vor der Abstimmung zunächst beim zuständigen
        Wahlamt registrieren lassen. Bei der Präsidentenwahl 2016 stimmten nach
        Angaben der Wahlkommission (FEC) knapp 137 Millionen Amerikaner ab.
        Gemessen an der Bevölkerung im wahlfähigen Alter von damals rund 245
        Millionen Menschen entsprach das einer Wahlbeteiligung von knapp 56
        Prozent.
      </>
    )
  },
  {
    q: 'Wie funktioniert das Wahlsystem?',
    a: (
      <>
        Die US-Wähler können nur indirekt darüber abstimmen, wer der nächste
        Präsident wird. Ihre Stimme entscheidet die Zusammensetzung des
        Wahlkollegiums («Electoral College»), das dann den Präsidenten wählt. In
        48 der 50 Bundesstaaten funktioniert das so: Der Kandidat, der sich eine
        Mehrheit sichern kann, bekommt alle Stimmen zugesprochen. Ein Beispiel:
        Falls Trump Florida mit 50,1 Prozent der Stimmen gewinnen sollte, bekäme
        er die Stimmen aller 29 Wahlleute, Biden ginge leer aus. Einzig in den
        kleinen Staaten Nebraska und Maine werden die Stimmen der Wahlleute
        annähernd proportional vergeben.
      </>
    )
  },
  {
    q: 'Was hat es mit den Wahlleuten auf sich?',
    a: (
      <>
        Die Anzahl der Wahlleute eines Bundesstaates entspricht jener der von
        dort entsandten US-Senatoren und Kongressabgeordneten. Die Wahlleute
        stimmen 41 Tage nach der Präsidentenwahl ab, dieses Jahr am 14.
        Dezember. Sie richten sich dabei nach dem Ergebnis in ihrem Bundesstaat.
        In vielen Staaten würde den Wahlmännern und Wahlfrauen sonst eine Strafe
        drohen. Um Präsident zu werden, muss ein Kandidat mindestens die Stimmen
        von 270 Wahlleuten gewinnen. Das Ergebnis wird offiziell erst am 6.
        Januar im Kongress bekanntgegeben. Wegen des indirekten Wahlsystems ist
        es möglich, dass ein Kandidat zwar die meisten Direktstimmen gewinnt,
        die Wahl aber trotzdem verliert. Das war zum Beispiel 2016 der Fall.
        Damals stimmten mehr Amerikaner für Hillary Clinton, Trump konnte sich
        aber durch die von ihm gewonnenen Bundesstaaten die Mehrheit der
        Wahlleute sichern.
      </>
    )
  },
  {
    q: 'Wann ist mit einem Ergebnis zu rechnen?',
    a: (
      <>
        Bei den meisten vergangenen Präsidentenwahlen stand der Sieger noch in
        der Wahlnacht fest. Experten gehen aber davon aus, dass in diesem Jahr
        wegen der Pandemie wesentlich mehr Menschen per Briefwahl abstimmen
        werden. Daher könnte sich die Auszählung in einigen Bundesstaaten,
        darunter Pennsylvania, um einige Tage verzögern. Zudem wollen Umfragen
        zufolge mehr Demokraten als Republikaner die Briefwahl nutzen. Daher
        könnten die ersten Auszählungsergebnisse aus den Wahllokalen mancherorts
        Trump in Führung sehen, die Auszählung der Briefwahlunterlagen letztlich
        aber Biden zum Sieg verhelfen. In einzelnen Bundesstaaten könnte es auch
        Klagen und Forderungen nach einer Neuauszählung geben. Im Jahr 2000 etwa
        stand das Ergebnis im Bundesstaat Florida, das letztlich über die
        Präsidentenwahl entschied, erst gut einen Monat nach der Wahl fest. Der
        Rechtsstreit ging bis vor das Oberste Gericht in Washington.
      </>
    )
  },
  {
    q: 'Wer gibt die Wahlergebnisse bekannt?',
    a: (
      <>
        Es gibt in den USA keine Wahlkommission oder Behörde, die zeitnah die
        Ergebnisse fürs ganze Land bekanntgibt. Eine wichtige Rolle kommt daher
        grossen US-Medien zu, die örtliche Ergebnisse zusammentragen und diese
        teils mit anderen Daten kombinieren, um zu prognostizieren, wer eine
        Wahl gewonnen hat. Als sehr verlässlich gelten die von der
        Nachrichtenagentur Associated Press (AP) ermittelten Ergebnisse.
      </>
    )
  },
  {
    q: 'Welche Rolle spielt die Briefwahl?',
    a: (
      <>
        Die Behörden rechnen wegen Corona mit einer massiven Zunahme der
        Briefwahl. Zudem findet die Wahl in den USA immer an einem normalen
        Arbeitstag statt. Deshalb stimmte zum Beispiel 2016 bereits fast ein
        Viertel der Wähler per Post ab. Das waren gut 33 Millionen Stimmen.
        Viele Bundesstaaten haben es wegen der Pandemie einfacher gemacht oder
        Fristen verlängert, um die Briefwahl zu ermöglichen. Manche Staaten wie
        zum Beispiel Kalifornien, Ohio und New Jersey schicken die
        Wahlunterlagen sogar unaufgefordert an die Bürger. In diesem Jahr könnte
        Experten zufolge jede zweite Stimme per Post kommen.
      </>
    )
  },
  {
    q: 'Wieso ist Briefwahl plötzlich so umstritten?',
    a: (
      <>
        Trump hat die etablierte Form der Abstimmung im Wahlkampf zum Zankapfel
        gemacht. Er warnte, dass die Zunahme der Briefwahl zu massiver
        Wahlfälschung führen werde. Vor allem kritisiert er, dass in manchen
        Staaten Wahlunterlagen unaufgefordert verschickt werden. Mancherorts
        würden Stimmzettel an «Tote und Hunde» verschickt, sagte Trump. Er
        betrachtet die Briefwahl als Finte der Demokraten, um ihn mit Hilfe
        einer hohen Wahlbeteiligung zu schlagen.
      </>
    )
  },
  {
    q: 'Was ist dran an Trumps Warnungen?',
    a: (
      <>
        Trump hat bislang keine stichhaltigen Beweise vorgelegt. Experten und
        selbst viele Republikaner weisen Trumps Warnungen zurück. Wahlbetrug ist
        in den USA sehr selten. Selbst kleinere Vergehen können hier zu
        Gefängnisstrafen führen. Experten der Denkfabrik Brennan Center zufolge
        waren bei untersuchten Abstimmungen nur rund 0,0025 Prozent der in
        Wahllokalen abgegebenen Stimmen von Betrug betroffen, bei Briefwahl
        sogar noch weniger. Die Wahrscheinlichkeit, dass ein Amerikaner die
        Briefwahl manipuliere, sei geringer als die Wahrscheinlichkeit, vom
        Blitz getroffen zu werden, hiess es.
      </>
    )
  },
  {
    q: 'Welche Folgen könnten Trumps Behauptungen haben?',
    a: (
      <>
        Viele Demokraten befürchten, dass Trump die Rechtmässigkeit der
        Abstimmung insgesamt in Frage stellen könnte. Das ist die Logik: Sollte
        er unterliegen, könnte er von Wahlbetrug sprechen und sich weigern, das
        Ergebnis anzuerkennen. Eine verzögerte Bekanntgabe des Ergebnisses
        könnte seinen Vorwürfen Rückenwind verschaffen. Das Szenario ist nicht
        aus der Luft gegriffen. Im August etwa sagte Trump mehrfach, er werde
        nur verlieren, «falls die Wahl manipuliert ist».
      </>
    )
  },
  {
    q: 'Wie geht es nach der Wahl weiter?',
    a: (
      <>
        Am 14. Dezember stimmen die 538 Wahlfrauen und Wahlmänner in ihren
        Bundesstaaten ab. Am 6. Januar wird im US-Kongress ab 19.00 Uhr bei
        einer gemeinsamen Sitzung der beiden Parlamentskammern dann offiziell
        bekanntgegeben, wer der nächste US-Präsident und Vizepräsident sein
        wird. Der neue Präsident leistet dann am 20. Januar bei einer festlichen
        Zeremonie vor dem Kapitol in Washington ab 18.00 Uhr seinen Amtseid ab
        («Inauguration»).
      </>
    )
  },
  {
    q: 'Was passiert, falls Trump eine Niederlage nicht anerkennt?',
    a: (
      <>
        Trump hat mehrfach offengelassen, ob er eine Niederlage akzeptieren
        wird. Es gibt in der jüngeren US-Geschichte kein Vorbild für ein
        Szenario, in dem sich der Amtsinhaber weigerte, seine Niederlage
        einzuräumen. Sollte es dazu kommen, dürfte sich die Spaltung des Landes
        in gegnerische politische Lager gefährlich zuspitzen, es wäre eine
        Verfassungskrise. Manche Experten warnen, dass es dann auch zu
        Massenprotesten und Gewalt kommen könnte.
      </>
    )
  },
  {
    q: 'Wie wichtig sind die Kongresswahlen?',
    a: (
      <>
        Ohne eine Mehrheit in beiden Kammern des Kongresses, dem
        Repräsentantenhaus und dem Senat, kann ein Präsident innenpolitisch nur
        wenig nachhaltig verändern. Das Parlament hat die Budgethoheit und das
        Vorschlagsrecht für Gesetze. Der Senat muss zudem bei der Besetzung
        aller herausragenden Regierungsämter zustimmen - vom Minister bis zum
        Botschafter. Gleiches gilt für die Ernennung wichtiger Richterposten.
        Zuletzt kontrollierten die Demokraten das Repräsentantenhaus, die
        Republikaner den Senat.
      </>
    )
  }
]
